<template>
  <vs-sidebar
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="assignable-crews-sidebar"
    spacer
    v-model="show"
  >
    <!-- ヘッダー部分 -->
    <div class="header-sidebar" slot="header">
      <vs-row>
        <h2 style="font-weight: normal;">配乗可能船員</h2>
      </vs-row>
      <vs-row>
        <h3 style="font-weight: normal;">{{ vesselName }}</h3>
      </vs-row>
      <vs-row>
        <h3 style="font-weight: normal;">{{ positionName }}</h3>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="5">
          <span><vs-icon icon="calendar_month"></vs-icon></span>
          <span style="margin: 0.5em;">{{ selectedDate }}</span>
        </vs-col>
      </vs-row>
    </div>
    <!-- カードリスト部分 -->
    <vs-list>
      <vs-list-item
        v-for="(crew, index) in assignableCrews"
        :key="index"
        class="crews-assignable-list-item"
      >
        <vs-row vs-justify="center">
          <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <assignable-crew-card
              :crew="crew"
              :vessel="vessel"
              @crewSelected="crewSelected"
            />
          </vs-col>
        </vs-row>
      </vs-list-item>
    </vs-list>
  </vs-sidebar>
</template>
<script>
import moment from "moment";
import AssignableCrewCard from "./AssignableCrewCard.vue";
import { EnterpriseManningVesselRolePositionService } from "../../../services/vessels/assignable-crews/AssainableCrewsService";
import { EnterpriseManningVesselsService } from "../../../services/master";
import { HandleHttpErrorService } from "../../../../utils/errors";

export default {
  name: "AssignableCrews",
  components: {
    AssignableCrewCard,
  },
  data() {
    return {
      show: false,
      resource: null,
      date: null,
      vessel: null,
      assignableCrews: [],
    };
  },
  watch: {
    show(newVal) {
      this.showSidebar = newVal;
    },
    showSidebar(newVal) {
      if (!newVal) {
        this.$emit("closed", newVal);
      }
    },
  },
  methods: {
    crewSelected(crew) {
      this.show = false;
      this.$emit("crewSelected", crew, this.resource, this.date);
    },
    async open(resource, date) {
      // 紐づくリソースIDの接頭語を削り、rolePositionIdを作成
      const rolePositionId = resource.id.split("p_")[1];

      // 配乗可能船員一覧取得
      try {
        const res = await EnterpriseManningVesselRolePositionService.fetch(
          rolePositionId,
          date
        );
        this.assignableCrews = res.crews;
      } catch (e) {
        const notificateMessage = HandleHttpErrorService.handleErrorNotificationMessage(
          e
        );
        this.$vs.notify({
          title: "配乗可能船員の取得に失敗しました",
          text: notificateMessage,
          color: "danger",
        });
        return;
      }
      this.show = true;
      this.resource = resource;
      this.date = date;

      const rootResource = this.getRootResource(this.resource);
      if (!rootResource) {
        return null;
      }

      const vesselId = rootResource.id.split("v_")[1];
      this.vessel = EnterpriseManningVesselsService.findById(vesselId);
    },

    // リソースのルートを取得する
    // TODO: あとでヘルパーに切り出す
    getRootResource(resource) {
      if (!resource || !resource.isLeaf) {
        return resource;
      }
      return this.getRootResource(resource.parent);
    },
  },
  computed: {
    positionName() {
      return this.resource ? this.resource.name : "";
    },

    vesselName() {
      if (!this.vessel) {
        return "";
      }

      return this.vessel.name;
    },

    selectedDate() {
      if (this.date) {
        return moment(this.date).format("YYYY/MM/DD");
      }

      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.assignable-crews-sidebar {
  :deep(.vs-list--item) {
    border-bottom: none !important;
  }

  :deep(.vs-sidebar) {
    max-width: 400px;
    background-color: #eceef2;
    border-radius: 0.8em 0 0 0;
  }
  :deep(.vs-list--slot) {
    width: 100%;
  }
  :deep(.header-sidebar) {
    width: 100%;
    background-color: #eceef2;
  }
  :deep(.vs-sidebar--header) {
    padding: 0px !important;
    margin-bottom: 4em;
  }

  :deep(.vs-sidebar--items) {
    overflow: auto !important;
  }

  :deep(.vs-sidebar--header) {
    border: 0px !important;
  }
}
</style>
